import { ConfirmOptions } from 'material-ui-confirm'
import ConfirmPaper, { CONFIRM_CANCEL_CLASS } from 'src/components/ConfirmPaper'

// ----------------------------------------------------------------------
// What every `useConfirm` dialog looks like, stated once.
//
// `material-ui-confirm` draws both of its buttons as plain text buttons and
// puts the confirmation on `color="primary"`. Forty-three call sites in this
// console open one, and until now every one of them took that: the way out
// and the thing being confirmed were the same control twice, drawn in the
// same ink at the same weight, with only the words to tell them apart. The
// four screens that had noticed had each hand-rolled their own repair, which
// is four places for the answer to live and therefore three places for it to
// be wrong.
//
// So it is stated here, on the provider, and a screen only names a button
// prop when the *consequence* differs: `color: 'error'` on a delete. The
// library merges `defaultOptions` into each call one level deep, so a screen
// that names `color` keeps the shape it did not name.
//
// The dismiss is `outlined` + `color="inherit"`, which is the same
// `outlinedInherit` slot `ActionRow` draws and the same reason: a dismiss
// beside a commit must not be the same object as the commit. This theme
// defaults every button to `secondary` and binds secondary to the accent, so
// two `contained` buttons in one row resolve to one fill, which is exactly
// what twenty-six dialog footers used to ship.
//
// It lives in its own module rather than inside `App.tsx` because the spec
// harness mounts its own `ConfirmProvider`, and a harness whose dialogs are
// drawn differently from the application's is a spec that passes on a screen
// the console draws wrongly.
//
// The paper carries the close mark every other dialog has, and the class on
// Cancel is how that mark finds the button it presses (`ConfirmPaper`).
// ----------------------------------------------------------------------

export const CONFIRM_DEFAULTS: ConfirmOptions = {
  dialogProps: { PaperComponent: ConfirmPaper },
  confirmationButtonProps: { variant: 'contained' },
  cancellationButtonProps: {
    variant: 'outlined',
    color: 'inherit',
    className: CONFIRM_CANCEL_CLASS,
  },
}
